import { render } from "./BotaoGerarRelatorio.vue?vue&type=template&id=cd3b65c0&scoped=true&ts=true"
import script from "./BotaoGerarRelatorio.vue?vue&type=script&lang=ts"
export * from "./BotaoGerarRelatorio.vue?vue&type=script&lang=ts"

import "./BotaoGerarRelatorio.vue?vue&type=style&index=0&id=cd3b65c0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3b65c0"]])

export default __exports__